import React, { useEffect, useRef, useState } from "react";

import { approvColumnsList } from "../columnsList";
import ApprovCard from "./ApprovCard";
import { useDispatch, useSelector } from "react-redux";
import { getApprovs } from "../../../REDUX/actions/approvisionnement";
import LoaderWrapper from "../../../Utils/ViewWrapper/LoaderWrapper/LoaderWrapper";
import { useInView } from "react-intersection-observer";
import { Spinner } from "react-bootstrap";
import { useTranslation } from "react-i18next";

const ApprovViewContent = ({ searchInput, filtersInput }) => {
  const { t } = useTranslation("common");
  const dispatch = useDispatch();
  const abortControllerRef = useRef(null);
  const { approvs, approvsLoading, approvsError, approvsRefetchLoading } =
    useSelector((state) => state.approvReducer);
  const { ref, inView, entry } = useInView({
    threshold: 0,
  });
  const [page, setpage] = useState(1);

  useEffect(() => {
    // dispatch(getApprovs({ page, searchInput }));
    if (inView && !approvsRefetchLoading) {
      abortControllerRef.current?.abort();
      abortControllerRef.current = new AbortController();
      setpage(page + 1);
      dispatch(
        getApprovs({ page, searchInput }, abortControllerRef.current.signal),
      );
    }
  }, [inView]);

  useEffect(() => {
    return () => {
      abortControllerRef.current?.abort();
    };
  }, []);

  return (
    <div className="flex-1 d-flex flex-column">
      <div className="bg-dimGrey py-3 px-4 mx-0 w-100 alignH">
        {approvColumnsList?.map(({ title, className }, index) => (
          <span
            key={index}
            className={`${className} text-lightBlack sBold f14`}
          >
            {t(`${title}`)}
          </span>
        ))}
        <span className={`w4 d-flex`}></span>
      </div>
      <div className="flex-1">
        <LoaderWrapper loading={approvsLoading} error={approvsError}>
          {approvs?.map((approv) => (
            <div key={approv?.id}>
              <ApprovCard {...approv} />
              <hr
                style={{ borderColor: "#abb8b2", margin: 0 }}
                width={"100%"}
              />
            </div>
          ))}
        </LoaderWrapper>
      </div>
      <div className="alignC mt-4" ref={ref}>
        {approvsRefetchLoading ? <Spinner /> : null}
      </div>
    </div>
  );
};

export default ApprovViewContent;
